__turbopack_context__.v({
  "actions": "TimeRangeFilter-module-scss-module__LRbMkW__actions",
  "column": "TimeRangeFilter-module-scss-module__LRbMkW__column",
  "customSectionWrapper": "TimeRangeFilter-module-scss-module__LRbMkW__customSectionWrapper",
  "divider": "TimeRangeFilter-module-scss-module__LRbMkW__divider",
  "panel": "TimeRangeFilter-module-scss-module__LRbMkW__panel",
  "radioGrid": "TimeRangeFilter-module-scss-module__LRbMkW__radioGrid",
  "radioGroup": "TimeRangeFilter-module-scss-module__LRbMkW__radioGroup",
  "section": "TimeRangeFilter-module-scss-module__LRbMkW__section",
  "title": "TimeRangeFilter-module-scss-module__LRbMkW__title",
});
